// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__e9RbQ","activePage":"Pagination_activePage__fFTL1","pageItem":"Pagination_pageItem__tuXYu"};